const cookChefService = {
  title: "Cook / Chef",
  icon: "👨‍🍳",
  rateCardKey: "cook-chef",
  shortDescription:
    "Home cooking support, meal preparation, special dishes, and recurring cook service.",
  longDescription:
    "Book cooking support for daily meals, meal prep routines, or occasional chef-style home cooking. Pricing depends on meal count, cuisine complexity, and hours required.",
  consultationNote:
    "Party catering, event cooking, or special diet meal planning should begin with consultation.",
  responsePromise:
    "Assignment depends on cuisine type, meal schedule, and cook availability.",
  warrantyPolicy:
    "Food taste and outcome vary by ingredients provided, kitchen condition, and recipe scope.",
  subServices: [
    {
      id: "cook-daily-basic",
      title: "Daily Home Cook - Basic Meals",
      icon: "🍛",
      group: "Recurring Support",
      description:
        "Recurring daily meal support for standard home breakfast/lunch/dinner cooking.",
      basePrice: 2499,
      priceType: "starts_at",
      duration: "Monthly plan",
      warranty: "Attendance/support policy",
      unit: "month",
    },
    {
      id: "cook-one-time-home-meal",
      title: "One-time Home Cooking Visit",
      icon: "🍲",
      group: "One-time",
      description:
        "One-time cooking support for a meal session in your kitchen.",
      basePrice: 599,
      priceType: "starts_at",
      duration: "2-4 hrs",
      warranty: "Visit completion only",
      unit: "visit",
    },
    {
      id: "cook-special-dish-session",
      title: "Special Dish / Cuisine Session",
      icon: "🥘",
      group: "Special Cooking",
      description:
        "Cook session for specific cuisine or complex home-cooked menu request.",
      basePrice: 899,
      priceType: "starts_at",
      duration: "2-5 hrs",
      warranty: "Visit completion only",
      unit: "session",
    },
    {
      id: "cook-party-consult",
      title: "Small Event Cooking Consultation",
      icon: "🎉",
      group: "Consultation",
      description:
        "Consultation for home event cooking support, people count, and menu planning.",
      basePrice: 399,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Consultation only",
      unit: "visit",
    },
  ],
};

export default cookChefService;